import moment from 'moment-timezone';

import { dateUtils } from '@sportheroes/oly-engine-utils';

export const FORMAT_DATE = 'YYYY/MM/DD';
export const FORMAT_DATE_TIME = 'YYYY-MM-DD[T]HH:mm';
export const FORMAT_UTC = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]';
export const FORMAT_FRIENDLY_TIME = 'YYYY/MM/DD [at] HH:mm';

export const timeToAmbiguousTime = time => {
  const timePattern = /[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}/;

  if (timePattern.test(time)) {
    return `${time.slice(0, 16)}:00`;
  }
  return null;
};

export const ambiguousTimeToFriendlyTime = (time, format = FORMAT_FRIENDLY_TIME) =>
  moment(time).format(format);

export const utcToLocalTime = time =>
  moment(time)
    .tz(moment.tz.guess())
    .format(FORMAT_FRIENDLY_TIME);

export const localTimeToUtc = date => moment.utc(date).format(FORMAT_UTC);

export const formatDateTime = date => (date ? moment(date).format(FORMAT_DATE_TIME) : null);

export const getTimezoneOffsetInHours = () => moment().tz(moment.tz.guess())._offset / 60;

export const getFormattedSeconds = duration =>
  duration ? dateUtils.getFormattedDuration({ duration, format: 'hhh:mm:ss' }) : null;

export const time = {
  utcToLocalTime,
  localTimeToUtc,
  formatDateTime,
  getTimezoneOffsetInHours,
};
